(function () {
  angular
    .module("akitabox.building")
    .controller("BuildingController", BuildingController);

  /* @ngInject */
  function BuildingController() {}
})();
